import { useMemo } from 'react';
import { Grid } from '@mui/material';
import { FormPart } from '@modules/shared/components/FormPart';
import { IFormFieldConfig } from '@shared/components/FormFieldsConstructor';
import { PageWrapper } from '@shared/styledComponents';
import { SaveButton } from '@shared/inputs/Buttons';
import { CommonButtonWrapper, PageContent } from '@styles/CommonStyles';
import { FileUpload } from './FileUpload';
import { IFileUpload } from './interfaces';

export interface IUploadFilesFormProps<T> {
  value: T;
  setFieldValue: (field: string, value: unknown, shouldValidate?: boolean) => void;
  formConfig: IFormFieldConfig<unknown>[];
}

export const FileUploadForm = <T extends IFileUpload>({
  value,
  setFieldValue: _setFieldValue,
  formConfig,
}: IUploadFilesFormProps<T>) => {
  const formParts = useMemo(() => {
    const formFileConfig: IFormFieldConfig<unknown>[] = [
      {
        width: '40%',
        name: 'document',
        component: FileUpload,
      },
    ];
    formConfig.map((formItem) => {
      formFileConfig.push(formItem);
    });
    return formFileConfig;
  }, [formConfig]);

  return (
    <PageWrapper>
      <PageContent>
        <Grid container spacing={3}>
          <Grid item md={12} lg={12} xl={12} sm={12} xs={12}>
            <FormPart config={formParts} />
          </Grid>
        </Grid>
      </PageContent>
      <CommonButtonWrapper>
        <SaveButton 
          label='Submit' 
          disabled={!value.document?.arrayBuffer} 
        />
      </CommonButtonWrapper>
    </PageWrapper>
  );
};
